import { lazy } from 'react';

const Assessment = lazy(() => import('./Assessment'));

export default Assessment;
